import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { SWReactIconProps } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";

export const StyledIntroductionView = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    background: ${colorsPalettes.carbon["0"]};
    stroke-width: 1px;
    stroke: #eee;
    filter: drop-shadow(0px 18px 34px rgba(14, 30, 62, 0.12));
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    /* margin: 8px 0; */
`;

export const StyledIntroductionViewInnerBlock = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 98px 0 98px;

    @media screen and (min-width: 1440px) and (max-width: 1920px) {
        justify-content: space-around;
        padding: 0 123px 0 144px;
    }

    @media screen and (min-width: 1920px) {
        justify-content: space-around;
    }
`;

export const ImageWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 435px;

    img {
        width: 435px;
    }

    @media screen and (min-width: 1440px) {
        width: 530px;

        img {
            width: 530px;
        }
    }
`;

export const StyledIntroductionBlock = styled(FlexColumn)`
    justify-content: center;
    width: 440px;

    @media screen and (min-width: 1920px) {
        width: 478px;
    }
`;
export const StyledHeaderIntroductionBlock = styled.div`
    ${mixins.setFontVariant("subsectionTitle", colorsPalettes.carbon["500"])}
    font-size: 40px;
    line-height: 48px;

    @media screen and (min-width: 1920px) {
        font-size: 48px;
    }
`;
export const StyledListIntroductionBlock = styled(FlexColumn)`
    align-items: flex-start;
`;
export const StyledListIntroItem = styled(FlexRow)`
    justify-content: space-between;
    margin-top: 24px;

    @media screen and (min-width: 1920px) {
        margin-top: 36px;
    }
`;

export const StyledListIntroItemText = styled.div`
    display: flex;
    ${mixins.setFontVariant("subTitle3Alt", colorsPalettes.carbon["500"])};
    line-height: 20px;
    width: calc(100% - 36px);
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
`;

export const StyledIntroViewAction = styled(FlexRow)`
    margin-top: 24px;
    padding-left: 36px;
`;

export const StyledIntentTopicsViewLink = styled.a`
    ${mixins.setFontVariant("button", colorsPalettes.blue["400"])};
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: background-color 0.2s ease-in-out;
    border-radius: 69px;

    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
    }
    &:active {
        background-color: ${colorsPalettes.blue[200]};
    }
`;

export const StyledIntroViewLink = styled(StyledIntentTopicsViewLink)`
    margin-left: 24px;
    padding: 0 16px;
`;

export const StyledIntroViewIcon = styled(SWReactIcons)`
    margin-left: 4px;

    & svg path {
        fill: ${colorsPalettes.blue["400"]};
        fill-opacity: 1;
        stroke: none;
    }
`;

export const CheckedIcon = styled(SWReactIcons).attrs<Partial<SWReactIconProps>>(({ size }) => ({
    iconName: "checked",
    size: size ?? "xs",
}))<Omit<SWReactIconProps, "iconName" | "size">>`
    display: flex;

    path {
        fill: ${colorsPalettes.mint["400"]};
        stroke: none;
    }
`;
